

export const initialValues = {
    firstName: '',
    lastName: '',
    addrCountry: 'Canada',
    phone: '',
    email: '',
    password: '',
    role: '',
    signature: null,
};